module.exports = __webpack_public_path__ + "img/flags/SZ.a3a45f3.png";